export type Globals = Omit<Partial<typeof globalThis>, 'window'> & { window?: Window };

export const getGlobals = (): Globals | undefined =>
  // eslint-disable-next-line no-restricted-globals
  typeof globalThis === 'object' ? globalThis : typeof window === 'object' ? window : undefined;
